import axiosIns from '@/api/axios'
import axiosInsAcademy from '@/api/axios-ugems-academy'

export const GET_COMPETENCIES = (params) => {
    return axiosInsAcademy.get('/competencies', { params })
}

export const CREATE_COMPETENCY = (data) => {
    return axiosInsAcademy.post('/competencies', data)
}

export const UPDATE_COMPETENCY = (id, data) => {
    return axiosInsAcademy.put(`/competencies/${id}`, data)
}

export const GET_COMPETENCY_BY_ID = (id) => {
    return axiosInsAcademy.get(`/competencies/${id}`)
}

export const DELETE_COMPETENCY = (id) => {
    return axiosInsAcademy.delete(`/competencies/${id}`)
}

export const GET_COMPETENCY = (args) => {
    return axiosIns.get('/master-data/competency', args)
}
export const GET_COMPETENCY_BY_NIK = (args) => {
    return axiosIns.get(`/master-data/competency-by-nik${args ? `?${args}` : ''}`)
}

export const DOWNLOAD_COMPETENCY_TEMPLATE = () => {
    return axiosInsAcademy.get('/competencies/download', {
        responseType: 'blob'
    })
}

export const UPLOAD_COMPETENCY_FILE = (formData) => {
    return axiosInsAcademy.post('/competencies/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

